import React from 'react'
import { Box, Typography } from '@mui/material'

import { defaultOptions } from '../../constants/joyride'

export const ONBOARDING_STEPS = [
  {
    content: (
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography variant='h6' gutterBottom component='div'>
          This is your Dashboard.
        </Typography>
        <Typography>
          Here, you can get a consolidated view of your team&apos;s data.
        </Typography>
      </Box>
    ),
    ...defaultOptions,
    placement: 'right',
    styles: {
      options: {
        zIndex: 10000
      }
    },
    target: '#dashboard__teamname'
  },
  {
    content: (
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography variant='h6' gutterBottom component='div'>
          Monitor your users&apos; data
        </Typography>
        <Typography>
          Here, you can view each user&apos;s mobile number, data usage and
          their monthly spending.
        </Typography>
      </Box>
    ),
    ...defaultOptions,
    placement: 'top-start',
    styles: {
      options: {
        zIndex: 10000
      }
    },
    target: '#teamMember__dataGrid'
  },
  {
    content: (
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography variant='h6' gutterBottom component='div'>
          Manage your SIMs
        </Typography>
        <Typography>
          Click on the button to manage and update users&apos; details, as well
          as add new users.
        </Typography>
      </Box>
    ),
    ...defaultOptions,
    placement: 'left',
    styles: {
      options: {
        zIndex: 10000
      }
    },
    target: '#manageSimsBtn'
  },
  {
    content: (
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography variant='h6' gutterBottom component='div'>
          Edit the user&apos;s access
        </Typography>
        <Typography>
          Click on the button to gain access to each uer&apos;s data usage and
          access to certain applications.
        </Typography>
      </Box>
    ),
    ...defaultOptions,
    placement: 'left',
    styles: {
      options: {
        zIndex: 10000
      }
    },
    target: '#editSimBtn'
  },
  {
    content: (
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography variant='h6' gutterBottom component='div'>
          Manage your account here.
        </Typography>
        <Typography>
          Adjust your account settings, revisit this walkthrough and others,
          view your changelog or logout.
        </Typography>
      </Box>
    ),
    ...defaultOptions,
    placement: 'top',
    target: '#sideNavBar_profileIcon'
  },
  {
    content: (
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography variant='h6' gutterBottom component='div'>
          Go through the other pages.
        </Typography>
        <Typography>
          Click on each of the other options in the Navigation Bar in sequence
          to learn more about what Orbit has to offer!
        </Typography>
      </Box>
    ),
    ...defaultOptions,
    placement: 'right',
    locale: { next: 'Close' },
    target: '#sideNavBar'
  },
  {
    content: (
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography variant='h6' gutterBottom component='div'>
          Purchase New SIMs
        </Typography>
        <Typography>
          Click on the button to buy new SIMs. An extensive walkthrough is
          available in the &apos;Walkthrough&apos; popup.
        </Typography>
      </Box>
    ),
    ...defaultOptions,
    placement: 'right',
    styles: {
      options: {
        zIndex: 10000
      }
    },
    target: '#shopfront__buyNewSimSection'
  },
  {
    content: (
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography variant='h6' gutterBottom component='div'>
          New Offers
        </Typography>
        <Typography>Look out for new items and offers in the Shop!</Typography>
      </Box>
    ),
    ...defaultOptions,
    placement: 'left',
    styles: {
      options: {
        zIndex: 10000
      }
    },
    target: '#shopfront__comingSoon'
  },
  {
    content: (
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography variant='h6' gutterBottom component='div'>
          View your Quotations
        </Typography>
        <Typography>
          Verify your quotation details here. After payment, your status would
          also be updated from pending to paid.
        </Typography>
      </Box>
    ),
    ...defaultOptions,
    placement: 'top-start',
    styles: {
      options: {
        zIndex: 10000
      }
    },
    target: '#quotes__quotationDataGrid'
  },
  {
    content: (
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography variant='h6' gutterBottom component='div'>
          Make your payment
        </Typography>
        <Typography>
          Click on this button to view or proceed with your payment.
        </Typography>
      </Box>
    ),
    ...defaultOptions,
    placement: 'top',
    styles: {
      options: {
        zIndex: 10000
      }
    },
    target: '#viewQuotation__viewBtn_9'
  },
  {
    content: (
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography variant='h6' gutterBottom component='div'>
          Check your order status here
        </Typography>
        <Typography>
          Verify your order details here. The status of each order will be
          updated accordingly at each stage.
        </Typography>
      </Box>
    ),
    ...defaultOptions,
    placement: 'top-start',
    styles: {
      options: {
        zIndex: 10000
      }
    },
    target: '#orders__ordersDataGrid'
  },
  {
    content: (
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography variant='h6' gutterBottom component='div'>
          View Order
        </Typography>
        <Typography>
          Click to view the specific details of each order.
        </Typography>
      </Box>
    ),
    ...defaultOptions,
    placement: 'top',
    styles: {
      options: {
        zIndex: 10000
      }
    },
    target: '#orders_viewBtn_9'
  },
  {
    content: (
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography variant='h6' gutterBottom component='div'>
          View your bills here.
        </Typography>
        <Typography>
          View invoices for your pending and paid bills, and pay those that are
          due.
        </Typography>
      </Box>
    ),
    ...defaultOptions,
    placement: 'top-start',
    styles: {
      options: {
        zIndex: 10000
      }
    },
    target: '#bills_billsDataGrid'
  },
  {
    content: (
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography variant='h6' gutterBottom component='div'>
          Manage individual users here.
        </Typography>
        <Typography>
          View and edit the profiles and roles of each member of your team.
        </Typography>
      </Box>
    ),
    ...defaultOptions,
    placement: 'top-start',
    styles: {
      options: {
        zIndex: 10000
      }
    },
    target: '#manageAccounts_dataGrid'
  },
  {
    content: (
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography variant='h6' gutterBottom component='div'>
          View your tickets here.
        </Typography>
        <Typography>
          View the status and history of your help requests, as well as any
          further actions required on your part.
        </Typography>
      </Box>
    ),
    ...defaultOptions,
    placement: 'top-start',
    styles: {
      options: {
        zIndex: 10000
      }
    },
    target: '#customerSupport__dataGrid'
  },
  {
    content: (
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography variant='h6' gutterBottom component='div'>
          Contact Customer Support.
        </Typography>
        <Typography>
          Click on the button to submit a help request. We will try to get back
          to you as soon as possible.
        </Typography>
      </Box>
    ),
    ...defaultOptions,
    placement: 'left',
    styles: {
      options: {
        zIndex: 10000
      }
    },
    target: '#customerSupport__addNewBtn'
  }
]

export const BUY_NEW_SIM_STEPS = [
  {
    content: (
      <div>
        This will be a guided walkthrough to buy new SIMs. <br />
        Click on Shop
      </div>
    ),
    ...defaultOptions,
    placement: 'right',
    styles: {
      options: {
        zIndex: 10000
      }
    },
    target: '#Shop'
  },
  {
    content: <div>Click on the Buy New SIMs button</div>,
    ...defaultOptions,
    placement: 'right',
    styles: {
      options: {
        zIndex: 10000
      }
    },
    target: '#buySIMButton'
  },
  {
    content: (
      <div>Enter the number of SIMs you wish to purchase, then click Next</div>
    ),
    ...defaultOptions,
    placement: 'top',
    locale: { next: 'Close' },
    styles: {
      options: {
        zIndex: 10000
      }
    },
    target: '#buyNewSim__input'
  },
  {
    content: (
      <div>
        Review your order details and ensure they are accurate. <br />
        Once reviewed, click Next
      </div>
    ),
    ...defaultOptions,
    placement: 'top-start',
    locale: { next: 'Close' },
    styles: {
      options: {
        zIndex: 10000
      }
    },
    target: '#buyNewSim__orderReview'
  },
  {
    content: <div>Select your preferred payment option</div>,
    ...defaultOptions,
    placement: 'left',
    styles: {
      options: {
        zIndex: 10000
      }
    },
    target: '#buyNewSim__paymentOptions'
  },
  {
    content: <div>This generates a quotation for your company...</div>,
    ...defaultOptions,
    placement: 'left',
    styles: {
      options: {
        zIndex: 10000
      }
    },
    target: '#generateQuotation'
  },
  {
    content: (
      <div>
        ... while this allows you to pay via Credit Card or Bank Transfer
      </div>
    ),
    ...defaultOptions,
    placement: 'left',
    locale: { last: 'End' },
    styles: {
      options: {
        zIndex: 10000
      }
    },
    target: '#confirmOrderButton'
  }
]

export const TRACK_ORDER_STEPS = [
  {
    content: (
      <div>
        This will be a guided walkthrough to track your order. <br />
        Click on Orders.
      </div>
    ),
    ...defaultOptions,
    placement: 'right',
    styles: {
      options: {
        zIndex: 10000
      }
    },
    target: '#Orders'
  },
  {
    content: <div>Here, you will see a list of your orders</div>,
    ...defaultOptions,
    placement: 'top-start',
    styles: {
      options: {
        zIndex: 10000
      }
    },
    target: '#orders__ordersDataGrid'
  },
  {
    content: (
      <div>
        Under each order, click on View to retrieve more information for each
        order
      </div>
    ),
    ...defaultOptions,
    placement: 'top-start',
    locale: { last: 'End' },
    styles: {
      options: {
        zIndex: 10000
      }
    },
    target: '#orders_viewBtn_9'
  }
]

export const MIGRATE_SIMS_STEPS = [
  {
    content: (
      <div>
        This will be a guided walkthrough to migrate your SIMs. <br />
        Click on Manage SIMs
      </div>
    ),
    ...defaultOptions,
    placement: 'left',
    locale: { next: 'Close' },
    styles: {
      options: {
        zIndex: 10000
      }
    },
    target: '#manageSimsBtn'
  },
  {
    content: (
      <div>There are 2 options to migrate SIMs: Add New or Batch Update</div>
    ),
    ...defaultOptions,
    placement: 'left',
    styles: {
      options: {
        zIndex: 10000
      }
    },
    target: '#simMgmt__migrateBtns'
  },
  {
    content: (
      <div>
        Batch Update allows you to utilise a CSV file to upload your SIMs.{' '}
        <br />
        Click on Batch Update
      </div>
    ),
    ...defaultOptions,
    placement: 'left',
    locale: { next: 'Close' },
    styles: {
      options: {
        zIndex: 10000
      }
    },
    target: '#simMgmt__batchUpdateBtn'
  },
  {
    content: (
      <div>
        Download the template and fill it up accordingly <br />
        Once completed, click Continue
      </div>
    ),
    ...defaultOptions,
    placement: 'left',
    styles: {
      options: {
        zIndex: 10000
      }
    },
    target: '#batchUpdate__downloadTemplateBtn'
  }
]
